/**
 * globals wordpress_globals
 */
import '../styles/theme.scss';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import convertDataAttributesToObject from './lib/convertDataAttributesToObejct';
import { fetchSVG, loadIcons } from './lib/SVGSprite';
import moduleDefinition, { ModuleDefinition } from './modules';

/**
 * Async Modules: Modules are defined in ./modules/definitions.ts
 */
const bootstrap = {
  init() {
    this.asyncModules.init(moduleDefinition);
    this.initNavBar();
  },
  initNavBar() {
    // Navbar Cross when menu is clicked
    const navbarToggler = document.querySelector<HTMLButtonElement>('.navbar-toggler');

    navbarToggler?.addEventListener('click', function () {
      // Add and remove the 'collapsed' class after a short delay to trigger animation
      setTimeout(() => {
        navbarToggler.classList.toggle('collapsed');
      }, 10); // 10ms delay to trigger the animation
    });
  },
  asyncModules: {
    init(modules: ModuleDefinition[]) {
      (modules ?? []).forEach(({ selector, moduleName, defaultArgs }) => {
        (document.querySelectorAll<HTMLElement>(selector) ?? []).forEach((el) => {
          const formattedArgs = convertDataAttributesToObject(el.dataset ?? {});
          const args = { ...defaultArgs, ...formattedArgs };

          return this.load(el, moduleName, args);
        });
      });
    },
    load: (el: HTMLElement, moduleName: string, args: Record<string, unknown>) => {
      try {
        return import(`./modules/${moduleName}`).then((mod) => {
          const Module = mod.default;
          return new Module(el, args);
        });
      } catch (error: unknown) {
        const err = error as Error;
        console.warn(err);
      }
      return false;
    },
  },
  asyncSVG: {
    init() {
      fetchSVG('./wp-content/themes/class/dist/sprite.svg')
        .catch((error: Error) => console.warn(`[fetchSVG] ${error}`));
    },
  },
};

document.addEventListener('DOMContentLoaded', () => {
  bootstrap.init();
});

// SVG Sprite Loader
loadIcons();
